export default __webpack_public_path__ + "static/banner-finance-experience-generation-9c14762310ebf9951a2dc27c6ad9a471.jpg";